export const sessionRefreshState = {
  lastRefreshAt: 0,
  refreshInFlight: null,
};

export function markSessionRefreshBaseline(atMs = Date.now()) {
  sessionRefreshState.lastRefreshAt = atMs;
  sessionRefreshState.refreshInFlight = null;
}
